const SKIP_LABELS = {
  donation_not_verified: "donation not verified yet (verify the donation first)",
  not_found: "not linked to an active donation payment",
  invalid_payment: "invalid payment id",
  invalid_flag: "invalid verification flag",
  unknown: "other",
};

/**
 * Human-readable suffix for accountant donation payment bulk verify responses.
 * @param {Record<string, number>|undefined} skipReasons
 */
export function formatDonationBulkPaymentSkipSuffix(skipReasons) {
  if (!skipReasons || typeof skipReasons !== "object") return "";
  const parts = Object.entries(skipReasons)
    .filter(([, n]) => Number(n) > 0)
    .map(([code, n]) => `${n} ${SKIP_LABELS[code] || String(code).replace(/_/g, " ")}`);
  if (!parts.length) return "";
  return ` Skipped because: ${parts.join("; ")}.`;
}
